export const uniqueCommonStyles = (FOUNDATIONS, FONT) => ({
    border_radius: FOUNDATIONS.radius_250,
});
export const defaultCommonStyles = (FOUNDATIONS, FONT) => ({
    background_color: FOUNDATIONS.color_neutral_bg_800,
});
export const pressedCommonStyles = (FOUNDATIONS, FONT) => ({
    background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
});
export const disabledCommonStyles = (FOUNDATIONS, FONT) => ({
    background_color: FOUNDATIONS.color_accent_disabled_bg_200,
});
export const firstCommonStyles = (FOUNDATIONS, FONT) => ({
    border_radius: `${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall}`,
});
export const middleCommonStyles = (FOUNDATIONS, FONT) => ({
    border_radius: FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall,
});
export const lastCommonStyles = (FOUNDATIONS, FONT) => ({
    border_radius: `${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_radiussizesmall} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius} ${FOUNDATIONS.radius_comp_navigation_navigationcard_borderradius}`,
});
//# sourceMappingURL=commonStyles.js.map